import { render, staticRenderFns } from "./Practitioner.vue?vue&type=template&id=6da1683d&"
import script from "./Practitioner.vue?vue&type=script&lang=js&"
export * from "./Practitioner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports